import { useContext } from "react";
import AuthContext from "../store/auth-context";
import { useNavigate } from "react-router-dom";

const useInterceptedNavigate = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  const interceptedNavigate = (to, options = {}) => {
    if (authContext.isFormDataChanged) {
      // If confirmation modal isn't open, show it and store the navigation
      if (!authContext.isConfirmationModalOpen) {
        authContext.pendingNavigationHandler(to); // Store pending navigation
        authContext.isConfirmationModalOpenHandler(true); // Show confirmation modal
      } else {
        navigate(to, options);
      }
    } else {
      // Proceed with navigation if form data hasn't changed
      navigate(to, options);
    }
  };

  return interceptedNavigate;
};

export default useInterceptedNavigate;
